import { Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import { CatMatch, MatchDiff } from '@shared/models/common';
import { NgRedux } from '@shared/redux/redux-compatibility.service';
import { AppState } from '@shared/redux/store';
import { getObjectPropValue } from '@shared/utils';
import { diff_match_patch } from '@shared/diff_match_patch_uncompressed.js';

@Component({
    selector: 'cat-match-phrase',
    templateUrl: './cat-match-phrase.component.html',
    styleUrls: ['./cat-match-phrase.component.scss'],
    standalone: false
})
export class CatMatchPhraseComponent implements OnInit {
  @Input() catMatch: CatMatch;

  @Input() disableConsistencyCheckResultsActions: boolean = false; 
  displayDocsSw: boolean= false;
  showOriginal: boolean = false;
  
  displayPercentMatch: boolean = false;
  percentMatchPropName: string = 'similarityPct';

  private diffTypeMapping = new Map<number, string>([
    [-1, 'MISSING'],
    [1, 'EXTRA'],
    [0, 'MATCH']
  ]);

  useCharBasedPhraseDiff: boolean = false;
  diffParts: MatchDiff[] = [];

  @Output() revertConsistencyCheckResultEmitter = new EventEmitter();

  constructor(private ngRedux: NgRedux<AppState>) {}

  ngOnInit(): void {
    if (this.catMatch.anchors == 'INCONSISTENT') {
      this.showOriginal = true;
    }
    console.log(this.catMatch);

    const uiConfig = this.ngRedux.getState().uiConfig;

    this.displayPercentMatch = getObjectPropValue(uiConfig, 'cat_match_phrase_display_settings.display_percent_match') ?? false;
    this.percentMatchPropName = getObjectPropValue(uiConfig, 'cat_match_phrase_display_settings.percent_match_prop_name') ?? 'similarityPct';
    
    this.useCharBasedPhraseDiff = getObjectPropValue(uiConfig, 'cat_match_phrase_display_settings.use_char_based_phrase_diff') ?? false;
  }

  revertConsistencyCheckResult() {
      this.catMatch.anchors = null;
      this.revertConsistencyCheckResultEmitter.emit();
  }

  getCharBasedPhraseDiffs(): MatchDiff[] {
    const workingPhrase = this.catMatch.phraseTxt;
    const matched = this.catMatch.catPhrase.phraseText;
    return new diff_match_patch().diff_main(workingPhrase, matched).map(part => {
      const matchDiff = new MatchDiff();
      matchDiff.text = part[1];
      matchDiff.diffType = this.diffTypeMapping.get(part[0]);
      return matchDiff;
    });
  }
}
